import { DefaultButton, LangBlockWrapper, TableSortWrapper } from "../styles";
import { LangTitleBox } from "../../../components/LangTitleBox/LangTitleBox";
import { ProjectEditPageGridRow } from "../../projectEdit/styles";
import { ProjectEditPageGridList } from "../../../../_deziiign/books/pages/BookEdit/styles";
import { CommonInput, CommonLabel, FlexBox, INPUT_TYPES, useBreakpoint } from "@brg/ui";
import { ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import { JustTable } from "../../../../_competition/components/style";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { Lang } from "@brg/api";
import { ReactComponent as DottedIcon } from "../handle.svg";
import { Input } from "@brg/input";
import EditIcon24 from "../../../icons/EditIcon24";
import { BasketIcon } from "../../projectEdit/BasketIcon";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ITeamTab } from "./TeamTabEdit";
import { createEmptyLangObject } from "../../../components/__ADDONS__/__SAFEAPI__/Empty";
import { ITeamFilterModel } from "./TeamFilterEditView";
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import {IModalSettings, setTextByLang} from "../TeamEdit";
import {LayoutConst, useModal} from "../../../../core";
import {generateUniqueString} from "../../../utils/generateUniqueString";
import DeleteIcon from "shared/icons/DeleteIcon";
import { useProfile } from "@brg/auth";

export enum TabType {
  tab = 'tab',
  category = 'category',
  shop = 'shop'
}

interface TeamTabsProps {
  type: TabType;
  tabs: ITeamTab[];
  setTabs: (tabs: ITeamTab[]) => void;
  onTabChange?: (tab: ITeamTab, index: number) => void;
  isMobile?: boolean;
  isS?: boolean;
  isChannel?: boolean;
  is1280?: boolean;
  hasHint?: boolean;
  hintMgs?: any;
  onModalStateChange: (show: boolean, settings: IModalSettings | null) => void;
  onLocalLangChange: (arr: any[], lang: string, callback: (test: any[]) => void) => void
}

const TeamTabsBlock = ({
  type,
  tabs,
  isMobile,
  isS,
  is1280,
  onLocalLangChange,
  onModalStateChange,
  onTabChange,
  setTabs,
  isChannel,
  hasHint,
  hintMgs 
}: TeamTabsProps) => {
  const { t, i18n: { language } } = useTranslation();
  const profile = useProfile();
  const currentLang = tabs?.find((tab) => tab?.currentLang)?.currentLang || 'ru';
  const modal = useModal();
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13);

  const onTeamTabSortEnd = useCallback((oldIndex: number, newIndex: number) => {
    const newTabs = arrayMoveImmutable(tabs, oldIndex, newIndex)
    setTabs(newTabs);
  }, [tabs]);

  const onTeamTabDelete = useCallback((index: number) => {
    const confirmation = window.confirm('Вы действительно хотите удалить вкладку?');
    if (confirmation) {
      const newTabs = [...tabs];
      const deletedTab = newTabs.splice(index, 1);
      const deletedProjectsIds = deletedTab[0]?.filter?.projectIds

      if (newTabs?.length > 0 && isChannel) {
        newTabs[0] = {
          ...newTabs[0], 
          filter: {
            ...newTabs?.[0]?.filter, 
            //@ts-ignore
            projectIds: [...new Set([
              ...(newTabs?.[0]?.filter?.projectIds || []), 
              ...(deletedProjectsIds || []) 
            ])] 
          }
        }
      }
      setTabs(newTabs);
    }
  }, [tabs, isChannel]);

  const onTeamTabAdd = useCallback(() => {
    const newTabs = [...tabs];
    newTabs.push({
      name: createEmptyLangObject('Вкладка без названия', ['ru', 'en']),
      about: createEmptyLangObject('', ['ru', 'en']),
      gridTitle: createEmptyLangObject('', ['ru', 'en']),
      gridTitleLink: createEmptyLangObject('', ['ru', 'en']),
      path: isChannel ? generateUniqueString(): '',
      filter: {} as ITeamFilterModel,
      isMain: tabs.filter(x => x.isMain).length === 0,
      entityType: '',
    });
    setTabs(newTabs);
  }, [tabs, isChannel]);

  const title = useMemo(() => {
    if (type === TabType.shop) {
      return t('teams.adminPage.fields.shop_tabs')
    }
    if (type === TabType.category) {
      return t('teams.adminPage.fields.categories')
    }
    return t('teams.adminPage.fields.tabs')
  }, [t, language])

  const hasProjects = (tab: any) => {
    const find = tabs?.find((i) => i?.path === tab?.path)
    //@ts-ignore
    return find && find?.filter?.projectIds?.length > 0
  } 

  const onEdit = (tab: any, index: any) => {
    if (isChannel) {
      // пока хз какое ограничение по проектам
      modal.show('send-project-longread',
          { 
            teamExtraFilter: {},
            maxProjects: 200,
            onlyOnePresentation: false,
            alreadyProjects: tab?.filter?.projectIds || [],
            onSelectProjects: (projectIds: any) => onTabChange?.({ ...tab, filter: {...(tab?.filter || {}), projectIds} }, index),
            // onlyAuthorProjects: true,
            contextsNotContains: ['greenaward'],
            status: [1, 10],
            hideBookmark: true,
            hideSearch: true,
            externalParams: {
              projectStatus: [1,10],
              onlyBooks: ' ',
              authorOrCoAuthorIds: !!tab?.filter?.projectIds?.length ? [] : [profile?.accountId],
              projectIds: tab?.filter?.projectIds || []
            },
            submitText: t('competition.save'),
            descriptionText: t('competition.channel_second_text', { tabName: Lang(tab.name, language) ?? ''})
          })
      return;
    }

    onModalStateChange(true, { mode: type, index: index })
  }

  return (
    <LangBlockWrapper 
      offsetTop={40} 
      offsetTopMobile={isS ? 24 : 40}
      {...(isChannel ? {
        direction: 'row',
        directionMobile: isS ? 'column' : 'row'
      } : { 
        direction: is1280 ? 'column' : 'row',
        directionMobile: isMobile ? 'column' : 'row'
      })} 
    >
      <FlexBox 
          widthMobile={isS ? '100%' : 'auto'}
          height={'100%'}
          offsetTop={14}
        >
        <CommonLabel 
          label={title}
          orientation="wide"
          infoText={hintMgs}
          onWhiteBG
          lang={currentLang}
          useLangSwitcher
          onLanguageChange={() => {
            onLocalLangChange(
              tabs, currentLang, (val) => setTabs(val)
            )
          }}
        />
      </FlexBox>

      <ProjectEditPageGridRow style={{ ...(isChannel && !!tabs?.length && { marginTop: 0 } )}} directionMobile={!!tabs?.length ? 'column' : 'row'} isTeamEdit>
        <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit>
          {!tabs?.length && (
            <FlexBox style={{ marginBottom: !tabs?.length ? 0 : 24 }}>
              <DefaultButton wh={195} whMob={195} onClick={() => onTeamTabAdd()}>
                <PlusSvg/>
                {isChannel ? t('teams.adminPage.buttons.add_tab') : t('teams.adminPage.buttons.add')}
              </DefaultButton>
            </FlexBox>
          )}
          {!!tabs?.length && (
            <JustTable isTeamEdit>
              <thead>
              {isChannel ? null :(
                <tr>
                  <th style={{ width: '45%' }}>{isChannel ? '' :t('teams.adminPage.additionalFields.td_name')}</th>
                  <th style={{
                    width: '22%',
                    whiteSpace: 'nowrap',
                    textAlign: 'center'
                  }}></th>
                  {!isS && (
                    <th style={{ width: isS ? 0 : '30%' }}></th>
                  )}
                </tr>
              )}
              </thead>
              <SortableList as={'tbody'} onSortEnd={onTeamTabSortEnd}>
                {tabs.map((tab, index) => {
                  const nameChannel = Lang(tab.name, currentLang, currentLang === 'ru' ? 'en' : 'ru');
                  const pureName = Lang(tab.name, currentLang) || t('teams.adminPage.buttons.empty');
                  return (
                    <SortableItem key={"team-tab-sortable_" + index}>
                      <tr style={{ ...(isChannel && isS && { display: 'block' }) }}>
                        <td 
                          style={{ 
                            width: isChannel && isS ? '100%' : 'auto', 
                            padding: isMobile ? `${(index === 0 && !isS) ? '0px' : '8px'} 12px 8px 0px` : 'inherit' 
                          }}>
                          <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                            <SortableKnob>
                              <div style={{ cursor: 'grab', backgroundColor: 'transparent' }}>
                                <DottedIcon/>
                              </div>
                            </SortableKnob>
                            <CommonInput 
                              type={INPUT_TYPES.text}
                              value={isChannel ? nameChannel : pureName}
                              disable={!isChannel}
                              maxLength={100}
                              onChange={(ev: any, lang?: string) => {
                                onTabChange?.(
                                    { ...tab, name: setTextByLang(tab.name, currentLang, ev.target.value) }, index)
                              }}
                            />
                          </TableSortWrapper>
                        </td>
                        {!isChannel && (
                          <td style={{ width: isS ? '70px' : '140px' }}>

                          </td>
                        )}
                        <td style={{ width: isS ? (isChannel && isS ? '100%' : '56px') : '336px', ...(isChannel && isS && { display: 'inline-block'}) }}>
                          <FlexBox 
                            direction={'row'} 
                            directionMobile={isS && isChannel ? 'row-reverse' : "row"} 
                            align="center" gx={isS ? 0 : 24} 
                            gxMobile={isS ? 0 : 24}
                            widthMobile={'100%'} 
                            justifyMobile={isS ? 'end' : 'start'}
                          >
                            {isS ? (
                              <>
                                {isChannel ? (
                                  <DefaultButton 
                                    wh={181} 
                                    whMob={157} 
                                    style={{ marginBottom: 5 }}
                                    onClick={() => onEdit(tab, index)}
                                  >
                                    {t(isChannel ? `teams.adminPage.buttons.${hasProjects(tab) ? 'change_projects' : 'add_projects'}` : 'teams.adminPage.buttons.edit')}
                                  </DefaultButton>
                                ) : (
                                  <EditIcon24 onClick={() => onEdit(tab, index)}/>
                                )}
                              </>
                            ) : (
                              <DefaultButton wh={181} whMob={157} style={{ marginBottom: 5, whiteSpace: 'nowrap' }}
                                             onClick={() => onEdit(tab, index)}>
                                {t(isChannel ? `teams.adminPage.buttons.${hasProjects(tab) ? 'change_projects' : 'add_projects'}`: 'teams.adminPage.buttons.edit')}
                              </DefaultButton>
                            )}
                            <FlexBox style={{ ...(isChannel && tabs?.length === 1 ? { display: 'none'} : {})}} offsetLeftMobile={isChannel && isS ? 1 : 8} offsetRightMobile={isChannel && isS ? 16 : 1}>
                              <DeleteIcon fill={'#838382'} onClick={() => onTeamTabDelete(index)}/>
                            </FlexBox>

                          </FlexBox>
                        </td>
                      </tr>
                    </SortableItem>
                  );
                })}
              </SortableList>
            </JustTable>
          )}
          {!!tabs?.length && (
            <FlexBox style={{ marginTop: !tabs?.length ? 0 : 24 }}>
              <DefaultButton wh={195} whMob={195} onClick={() => onTeamTabAdd()}>
                <PlusSvg/>
                {isChannel ? t('teams.adminPage.buttons.add_tab') : t('teams.adminPage.buttons.add')}
              </DefaultButton>
            </FlexBox>
          )}

        </ProjectEditPageGridList>
      </ProjectEditPageGridRow>
    </LangBlockWrapper>
  )
};

export default TeamTabsBlock;import { DefaultButton, LangBlockWrapper, TableSortWrapper } from "../styles";
import { LangTitleBox } from "../../../components/LangTitleBox/LangTitleBox";
import { ProjectEditPageGridRow } from "../../projectEdit/styles";
import { ProjectEditPageGridList } from "../../../../_deziiign/books/pages/BookEdit/styles";
import { CommonInput, CommonLabel, FlexBox, INPUT_TYPES, useBreakpoint } from "@brg/ui";
import { ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import { JustTable } from "../../../../_competition/components/style";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { Lang } from "@brg/api";
import { ReactComponent as DottedIcon } from "../handle.svg";
import { Input } from "@brg/input";
import EditIcon24 from "../../../icons/EditIcon24";
import { BasketIcon } from "../../projectEdit/BasketIcon";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ITeamTab } from "./TeamTabEdit";
import { createEmptyLangObject } from "../../../components/__ADDONS__/__SAFEAPI__/Empty";
import { ITeamFilterModel } from "./TeamFilterEditView";
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import {IModalSettings, setTextByLang} from "../TeamEdit";
import {LayoutConst, useModal} from "../../../../core";
import {generateUniqueString} from "../../../utils/generateUniqueString";
import DeleteIcon from "shared/icons/DeleteIcon";
import { useProfile } from "@brg/auth";

export enum TabType {
  tab = 'tab',
  category = 'category',
  shop = 'shop'
}

interface TeamTabsProps {
  type: TabType;
  tabs: ITeamTab[];
  setTabs: (tabs: ITeamTab[]) => void;
  onTabChange?: (tab: ITeamTab, index: number) => void;
  isMobile?: boolean;
  isS?: boolean;
  isChannel?: boolean;
  is1280?: boolean;
  hasHint?: boolean;
  hintMgs?: any;
  onModalStateChange: (show: boolean, settings: IModalSettings | null) => void;
  onLocalLangChange: (arr: any[], lang: string, callback: (test: any[]) => void) => void
}

const TeamTabsBlock = ({
  type,
  tabs,
  isMobile,
  isS,
  is1280,
  onLocalLangChange,
  onModalStateChange,
  onTabChange,
  setTabs,
  isChannel,
  hasHint,
  hintMgs 
}: TeamTabsProps) => {
  const { t, i18n: { language } } = useTranslation();
  const profile = useProfile();
  const currentLang = tabs?.find((tab) => tab?.currentLang)?.currentLang || 'ru';
  const modal = useModal();
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13);

  const onTeamTabSortEnd = useCallback((oldIndex: number, newIndex: number) => {
    const newTabs = arrayMoveImmutable(tabs, oldIndex, newIndex)
    setTabs(newTabs);
  }, [tabs]);

  const onTeamTabDelete = useCallback((index: number) => {
    const confirmation = window.confirm('Вы действительно хотите удалить вкладку?');
    if (confirmation) {
      const newTabs = [...tabs];
      const deletedTab = newTabs.splice(index, 1);
      const deletedProjectsIds = deletedTab[0]?.filter?.projectIds

      if (newTabs?.length > 0 && isChannel) {
        newTabs[0] = {
          ...newTabs[0], 
          filter: {
            ...newTabs?.[0]?.filter, 
            //@ts-ignore
            projectIds: [...new Set([
              ...(newTabs?.[0]?.filter?.projectIds || []), 
              ...(deletedProjectsIds || []) 
            ])] 
          }
        }
      }
      setTabs(newTabs);
    }
  }, [tabs, isChannel]);

  const onTeamTabAdd = useCallback(() => {
    const newTabs = [...tabs];
    newTabs.push({
      name: createEmptyLangObject('Вкладка без названия', ['ru', 'en']),
      about: createEmptyLangObject('', ['ru', 'en']),
      gridTitle: createEmptyLangObject('', ['ru', 'en']),
      gridTitleLink: createEmptyLangObject('', ['ru', 'en']),
      path: isChannel ? generateUniqueString(): '',
      filter: {} as ITeamFilterModel,
      isMain: tabs.filter(x => x.isMain).length === 0,
      entityType: '',
    });
    setTabs(newTabs);
  }, [tabs, isChannel]);

  const title = useMemo(() => {
    if (type === TabType.shop) {
      return t('teams.adminPage.fields.shop_tabs')
    }
    if (type === TabType.category) {
      return t('teams.adminPage.fields.categories')
    }
    return t('teams.adminPage.fields.tabs')
  }, [t, language])

  const hasProjects = (tab: any) => {
    const find = tabs?.find((i) => i?.path === tab?.path)
    //@ts-ignore
    return find && find?.filter?.projectIds?.length > 0
  } 

  const onEdit = (tab: any, index: any) => {
    if (isChannel) {
      // пока хз какое ограничение по проектам
      modal.show('send-project-longread',
          { 
            teamExtraFilter: {},
            maxProjects: 200,
            onlyOnePresentation: false,
            alreadyProjects: tab?.filter?.projectIds || [],
            onSelectProjects: (projectIds: any) => onTabChange?.({ ...tab, filter: {...(tab?.filter || {}), projectIds} }, index),
            // onlyAuthorProjects: true,
            contextsNotContains: ['greenaward'],
            status: [1, 10],
            hideBookmark: true,
            hideSearch: true,
            externalParams: {
              projectStatus: [1,10],
              onlyBooks: ' ',
              authorOrCoAuthorIds: !!tab?.filter?.projectIds?.length ? [] : [profile?.accountId],
              projectIds: tab?.filter?.projectIds || []
            },
            submitText: t('competition.save'),
            descriptionText: t('competition.channel_second_text', { tabName: Lang(tab.name, language) ?? ''})
          })
      return;
    }

    onModalStateChange(true, { mode: type, index: index })
  }

  return (
    <LangBlockWrapper 
      offsetTop={40} 
      offsetTopMobile={isS ? 24 : 40}
      {...(isChannel ? {
        direction: 'row',
        directionMobile: isS ? 'column' : 'row'
      } : { 
        direction: is1280 ? 'column' : 'row',
        directionMobile: isMobile ? 'column' : 'row'
      })} 
    >
      <FlexBox 
          widthMobile={isS ? '100%' : 'auto'}
          height={'100%'}
          offsetTop={14}
        >
        <CommonLabel 
          label={title}
          orientation="wide"
          infoText={hintMgs}
          onWhiteBG
          lang={currentLang}
          useLangSwitcher
          onLanguageChange={() => {
            onLocalLangChange(
              tabs, currentLang, (val) => setTabs(val)
            )
          }}
        />
      </FlexBox>

      <ProjectEditPageGridRow style={{ ...(isChannel && !!tabs?.length && { marginTop: 0 } )}} directionMobile={!!tabs?.length ? 'column' : 'row'} isTeamEdit>
        <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit>
          {!tabs?.length && (
            <FlexBox style={{ marginBottom: !tabs?.length ? 0 : 24 }}>
              <DefaultButton wh={195} whMob={195} onClick={() => onTeamTabAdd()}>
                <PlusSvg/>
                {isChannel ? t('teams.adminPage.buttons.add_tab') : t('teams.adminPage.buttons.add')}
              </DefaultButton>
            </FlexBox>
          )}
          {!!tabs?.length && (
            <JustTable isTeamEdit>
              <thead>
              {isChannel ? null :(
                <tr>
                  <th style={{ width: '45%' }}>{isChannel ? '' :t('teams.adminPage.additionalFields.td_name')}</th>
                  <th style={{
                    width: '22%',
                    whiteSpace: 'nowrap',
                    textAlign: 'center'
                  }}></th>
                  {!isS && (
                    <th style={{ width: isS ? 0 : '30%' }}></th>
                  )}
                </tr>
              )}
              </thead>
              <SortableList as={'tbody'} onSortEnd={onTeamTabSortEnd}>
                {tabs.map((tab, index) => {
                  const nameChannel = Lang(tab.name, currentLang, currentLang === 'ru' ? 'en' : 'ru');
                  const pureName = Lang(tab.name, currentLang) || t('teams.adminPage.buttons.empty');
                  return (
                    <SortableItem key={"team-tab-sortable_" + index}>
                      <tr style={{ ...(isChannel && isS && { display: 'block' }) }}>
                        <td 
                          style={{ 
                            width: isChannel && isS ? '100%' : 'auto', 
                            padding: isMobile ? `${(index === 0 && !isS) ? '0px' : '8px'} 12px 8px 0px` : 'inherit' 
                          }}>
                          <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                            <SortableKnob>
                              <div style={{ cursor: 'grab', backgroundColor: 'transparent' }}>
                                <DottedIcon/>
                              </div>
                            </SortableKnob>
                            <CommonInput 
                              type={INPUT_TYPES.text}
                              value={isChannel ? nameChannel : pureName}
                              disable={!isChannel}
                              maxLength={100}
                              onChange={(ev: any, lang?: string) => {
                                onTabChange?.(
                                    { ...tab, name: setTextByLang(tab.name, currentLang, ev.target.value) }, index)
                              }}
                            />
                          </TableSortWrapper>
                        </td>
                        {!isChannel && (
                          <td style={{ width: isS ? '70px' : '140px' }}>

                          </td>
                        )}
                        <td style={{ width: isS ? (isChannel && isS ? '100%' : '56px') : '336px', ...(isChannel && isS && { display: 'inline-block'}) }}>
                          <FlexBox 
                            direction={'row'} 
                            directionMobile={isS && isChannel ? 'row-reverse' : "row"} 
                            align="center" gx={isS ? 0 : 24} 
                            gxMobile={isS ? 0 : 24}
                            widthMobile={'100%'} 
                            justifyMobile={isS ? 'end' : 'start'}
                          >
                            {isS ? (
                              <>
                                {isChannel ? (
                                  <DefaultButton 
                                    wh={181} 
                                    whMob={157} 
                                    style={{ marginBottom: 5 }}
                                    onClick={() => onEdit(tab, index)}
                                  >
                                    {t(isChannel ? `teams.adminPage.buttons.${hasProjects(tab) ? 'change_projects' : 'add_projects'}` : 'teams.adminPage.buttons.edit')}
                                  </DefaultButton>
                                ) : (
                                  <EditIcon24 onClick={() => onEdit(tab, index)}/>
                                )}
                              </>
                            ) : (
                              <DefaultButton wh={181} whMob={157} style={{ marginBottom: 5, whiteSpace: 'nowrap' }}
                                             onClick={() => onEdit(tab, index)}>
                                {t(isChannel ? `teams.adminPage.buttons.${hasProjects(tab) ? 'change_projects' : 'add_projects'}`: 'teams.adminPage.buttons.edit')}
                              </DefaultButton>
                            )}
                            <FlexBox style={{ ...(isChannel && tabs?.length === 1 ? { display: 'none'} : {})}} offsetLeftMobile={isChannel && isS ? 1 : 8} offsetRightMobile={isChannel && isS ? 16 : 1}>
                              <DeleteIcon fill={'#838382'} onClick={() => onTeamTabDelete(index)}/>
                            </FlexBox>

                          </FlexBox>
                        </td>
                      </tr>
                    </SortableItem>
                  );
                })}
              </SortableList>
            </JustTable>
          )}
          {!!tabs?.length && (
            <FlexBox style={{ marginTop: !tabs?.length ? 0 : 24 }}>
              <DefaultButton wh={195} whMob={195} onClick={() => onTeamTabAdd()}>
                <PlusSvg/>
                {isChannel ? t('teams.adminPage.buttons.add_tab') : t('teams.adminPage.buttons.add')}
              </DefaultButton>
            </FlexBox>
          )}

        </ProjectEditPageGridList>
      </ProjectEditPageGridRow>
    </LangBlockWrapper>
  )
};

export default TeamTabsBlock;